export default __webpack_public_path__ + "static/media/Mt_Baker.f91c1c14.mp4";